(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Tridi", [], factory);
	else if(typeof exports === 'object')
		exports["Tridi"] = factory();
	else
		root["Tridi"] = factory();
})(self, function() {
return 